import type { Entry } from "contentful";
import type { TypeHeroSkeleton } from "@/types/contentful/generated";
import { mapEntryExperiences, type VariantData } from "./mapEntryExperiences";

type HeroEntry = Entry<TypeHeroSkeleton, undefined, string>;

export type HeroVariantData = VariantData<HeroEntry["fields"]>;

export const mapHeroExperiences = (experiences: unknown[] | undefined) =>
  mapEntryExperiences<HeroEntry["fields"]>(experiences, "hero");
